import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SelfDisclosureQuestion } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';
import { FormFieldLabelComponent } from '../../../components/legacy/form/form-field/form-field-label/form-field-label.component';
import { AppInputDirective } from '../../../components/legacy/form/controls/input/input.directive';

@Component({
  selector: 'app-self-disclosure-flat',
  templateUrl: './self-disclosure-flat.component.html',
  styleUrls: ['./self-disclosure-flat.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FormFieldComponent,
    FormFieldLabelComponent,
    AppInputDirective
  ]
})
export class SelfDisclosureFlatComponent {
  readonly selfDisclosureQuestion = input<SelfDisclosureQuestion>(undefined);
  readonly form = input<FormGroup>(undefined);

  public get getFormControl() {
    return this.form().get('answer') as FormGroup;
  }
}
